import SgPanel from '../../features/sg/layouts/panel';

// TSS vite/01 §"Pages are thin". /admin/sg — Software Ganadero: panel con tabs
// (Backups | Animales SG).
export default function SgPage() {
    return <SgPanel />;
}
